import { parse, format } from "date-fns";
import { fromPromise } from "xstate";

import type { ValidatePatientResponseWithScheduledAppointments } from "@/lib/__generated/api";
import { DigitalVisitReasonEnum } from "@/lib/__generated/api";
import { validatePatient } from "@/lib/services/validatePatient";

export interface ValidatePatientInput {
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  phoneNumber?: string;
  facilityCode?: string;
  digitalVisitReason?: DigitalVisitReasonEnum;
}

export const validatePatientActor = fromPromise<
  ValidatePatientResponseWithScheduledAppointments,
  ValidatePatientInput
>(async ({ input }): Promise<ValidatePatientResponseWithScheduledAppointments> => {
  const parsed = (dateOfBirth: string | undefined | null) =>
    parse(dateOfBirth ?? "", "MM/dd/yyyy", new Date());
  // v2/account/validate takes MM-dd-yyyy, unlike v2/facilities/appointments which takes
  // yyyy-MM-dd. Matches the legacy scheduler's formatDateForValidation().
  const validationDateOfBirth = (dob: string | undefined | null) =>
    format(parsed(dob), "MM-dd-yyyy");
  const rawPhoneNumber = (phoneNumber: string | undefined | null) =>
    phoneNumber?.replaceAll(/\D/g, "") ?? "";

  const result = await validatePatient({
    firstName: input?.firstName,
    lastName: input?.lastName,
    dateOfBirth: validationDateOfBirth(input?.dateOfBirth),
    phoneNumber: rawPhoneNumber(input?.phoneNumber),
    facilityCode: input?.facilityCode,
    digitalVisitReason: input?.digitalVisitReason,
  });

  return result as ValidatePatientResponseWithScheduledAppointments;
});
